var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-page", attrs: { id: "box" } },
    [
      _c("Header"),
      _c("Menulist"),
      _vm.payTestShow()
        ? _c(
            "div",
            { staticClass: "paydemo", staticStyle: { width: "100%" } },
            [
              _c("div", { staticClass: "paydemo-type-content" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showTitle("WX"),
                        expression: "showTitle('WX')",
                      },
                    ],
                    staticClass: "paydemo-type-name article-title",
                  },
                  [_vm._v(" 微信支付 ")]
                ),
                _c("div", { staticClass: "paydemo-type-body" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.appPaywayList.indexOf("WX_NATIVE") >= 0,
                          expression: "appPaywayList.indexOf('WX_NATIVE') >= 0",
                        },
                      ],
                      staticClass: "paydemo-type color-change",
                      class: { this: _vm.currentWayCode === "WX_NATIVE" },
                      on: {
                        click: function ($event) {
                          return _vm.changeCurrentWayCode(
                            "WX_NATIVE",
                            "codeImgUrl"
                          )
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "paydemo-type-img",
                        attrs: {
                          src: require("@/assets/payTestImg/wx_native.svg"),
                        },
                      }),
                      _c("span", { staticClass: "color-change" }, [
                        _vm._v("微信二维码"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.appPaywayList.indexOf("WX_BAR") >= 0,
                          expression: "appPaywayList.indexOf('WX_BAR') >= 0",
                        },
                      ],
                      staticClass: "paydemo-type color-change",
                      class: { this: _vm.currentWayCode === "WX_BAR" },
                      on: {
                        click: function ($event) {
                          return _vm.changeCurrentWayCode("WX_BAR", "")
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "paydemo-type-img",
                        attrs: {
                          src: require("@/assets/payTestImg/wx_bar.svg"),
                        },
                      }),
                      _c("span", { staticClass: "color-change" }, [
                        _vm._v("微信条码"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.appPaywayList.indexOf("WX_JSAPI") >= 0,
                          expression: "appPaywayList.indexOf('WX_JSAPI') >= 0",
                        },
                      ],
                      staticClass: "paydemo-type color-change",
                      class: { this: _vm.currentWayCode === "WX_JSAPI" },
                      on: {
                        click: function ($event) {
                          return _vm.changeCurrentWayCode(
                            "WX_JSAPI",
                            "codeImgUrl"
                          )
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "paydemo-type-img",
                        attrs: {
                          src: require("@/assets/payTestImg/wx_jsapi.svg"),
                        },
                      }),
                      _c("span", { staticClass: "color-change" }, [
                        _vm._v("公众号/小程序"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.appPaywayList.indexOf("WX_H5") >= 0,
                          expression: "appPaywayList.indexOf('WX_H5') >= 0",
                        },
                      ],
                      staticClass: "paydemo-type-h5",
                      class: { this: _vm.currentWayCode === "WX_H5" },
                      on: {
                        click: function ($event) {
                          return _vm.changeCurrentWayCode("WX_H5", "payurl")
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "paydemo-type-img",
                        attrs: {
                          src: require("@/assets/payTestImg/wx_h5.svg"),
                        },
                      }),
                      _c("span", { staticClass: "color-change" }, [
                        _vm._v("微信H5"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "page-main" },
        [
          !_vm.appId
            ? _c("div", { staticClass: "page-alert" }, [
                _vm._v("请选择应用APPID"),
              ])
            : _vm.noConfigText
            ? _c("div", { staticClass: "page-alert" }, [
                _vm._v("您尚未配置任何支付方式"),
              ])
            : _vm._e(),
          _c(
            "el-card",
            { staticClass: "list-card" },
            [
              _c(
                "div",
                {
                  staticClass: "card-head",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "card-head__title" }, [
                    _vm._v("我的终端"),
                  ]),
                  _c(
                    "span",
                    { staticClass: "card-head__right" },
                    [
                      _c("span", { staticClass: "card-head__count" }, [
                        _vm._v("共 " + _vm._s(_vm.total) + " 条"),
                      ]),
                      _vm.vallist.length != 0
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.handlePay },
                            },
                            [_vm._v("确认支付")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-table",
                {
                  key: "tableKey",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.datas,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "终端名称", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.title))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "型号", width: "190", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.model))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "终端医保SN", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.ybsn))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "终端设备SN", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.sn))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "单位名称", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: row.ybdept,
                                  placement: "top-start",
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(row.ybdept))])]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "联系人", width: "90" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.uname))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "联系电话", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.uphone))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "服务到期时间",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.endtime))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "到期天数", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDaysDifference(row.endtime) == 0
                                      ? "已过期"
                                      : _vm.getDaysDifference(row.endtime)
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      "class-name": "small-padding",
                      label: "操作",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row, $index }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  plain: "",
                                  size: "mini",
                                  type: "warning",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.chakanLook(row, 2)
                                  },
                                },
                              },
                              [_vm._v(" 查看 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "list-card__pager" },
                [
                  _vm.total > 0
                    ? _c("pagination", {
                        attrs: {
                          limit: _vm.listQuery.pagesize,
                          page: _vm.listQuery.page,
                          total: _vm.total,
                        },
                        on: {
                          "update:limit": function ($event) {
                            return _vm.$set(_vm.listQuery, "pagesize", $event)
                          },
                          "update:page": function ($event) {
                            return _vm.$set(_vm.listQuery, "page", $event)
                          },
                          pagination: _vm.getlist,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialogVisibleDetails,
            width: "45%",
            "custom-class": "detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleDetails = $event
            },
          },
        },
        [
          _c("el-divider", { attrs: { "content-position": "center" } }, [
            _vm._v("使用单位信息"),
          ]),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("单位名称："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.ybdept)),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("信用代码："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.yscode)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("联系人："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.uname)),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("联系方式："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.uphone)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider", { attrs: { "content-position": "center" } }, [
            _vm._v("终端信息"),
          ]),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("终端名称："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.title)),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("终端型号："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.model)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("设备SN："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.sn)),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("医保SN："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.ybsn)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("生产厂家："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.manufacturer)),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "box_list" }, [
                      _c("div", { staticClass: "box_list_title" }, [
                        _vm._v("服务到期时间："),
                      ]),
                      _c("div", { staticClass: "box_list_content" }, [
                        _vm._v(_vm._s(_vm.orderinfo.endtime)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer detail-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleDetails = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleDetails = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("pay-test-modal", {
        ref: "payTestModal",
        on: {
          closeBarCode: function ($event) {
            _vm.$refs.payTestBarCode.visible = false
          },
        },
      }),
      _c("pay-test-bar-code", {
        ref: "payTestBarCode",
        on: {
          CodeAgainChange: _vm.testCodeChange,
          barCodeValue: _vm.barCodeChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认支付",
            visible: _vm.dialogVisible,
            width: "720px",
            "custom-class": "pay-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "购买套餐", prop: "priceid" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm.priceid,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "priceid", $$v)
                        },
                        expression: "ruleForm.priceid",
                      },
                    },
                    _vm._l(_vm.priceList, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.id, attrs: { label: item.id, border: "" } },
                        [
                          _vm._v(_vm._s(item.description) + " "),
                          _c("i", [_vm._v(_vm._s(item.price) + "元")]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择年限", prop: "totalnum" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 1, max: 20 },
                            model: {
                              value: _vm.ruleForm.totalnum,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "totalnum", $$v)
                              },
                              expression: "ruleForm.totalnum",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "支付方式", prop: "paymethod" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.ruleForm.paymethod,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "paymethod", $$v)
                                },
                                expression: "ruleForm.paymethod",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: 1, border: "" } },
                                [_vm._v("线上支付")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: { type: "email", placeholder: "请输入邮箱" },
                            model: {
                              value: _vm.ruleForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "email", $$v)
                              },
                              expression: "ruleForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "发票规则" } }, [
                        _c("div", [
                          _vm._v(
                            "发票将在支付成功后3-5个工作日发送邮箱（注：不要填写企业内部邮件地址）"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位名称", prop: "company" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入联系人",
                              disabled: "",
                            },
                            model: {
                              value: _vm.ruleForm.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "company", $$v)
                              },
                              expression: "ruleForm.company",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "信用代码", prop: "yscode" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入联系电话",
                              disabled: "",
                            },
                            model: {
                              value: _vm.ruleForm.yscode,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "yscode", $$v)
                              },
                              expression: "ruleForm.yscode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入联系人",
                              disabled: "",
                            },
                            model: {
                              value: _vm.ruleForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "name", $$v)
                              },
                              expression: "ruleForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话", prop: "phone" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入联系电话",
                              disabled: "",
                            },
                            model: {
                              value: _vm.ruleForm.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "phone", $$v)
                              },
                              expression: "ruleForm.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("立即支付")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }